import Audio from '../../node/Audio';
import Text from '../../node/Text';
import { Milliseconds } from '@ef-carbon/primitive';
export class Item {
    constructor({start, end, text, audio}) {
        this.start = new Milliseconds(start);
        const e = end;
        this.end = new Milliseconds(e === undefined || e === null ? Infinity : e, { min: 0 });
        this.text = new Text(text);
        this.audio = new Audio(audio);
        if (+this.end !== Infinity && +this.end < +this.start) {
            const swap = this.start;
            this.start = this.end;
            this.end = swap;
        }
        const descriptors = Object.getOwnPropertyDescriptors(this);
        descriptors.start.configurable = false;
        descriptors.end.configurable = false;
        descriptors.text.configurable = false;
        descriptors.audio.configurable = false;
        Object.defineProperties(this, descriptors);
    }
}
export default Item;    //# sourceMappingURL=Item.js.map
